/**
 * useBankAccounts Hook
 * 
 * Custom hook for fetching and managing bank accounts data.
 */

import * as React from "react";
import { bankAccountService, type BankAccount } from "@/services/bankAccountService";

export function useBankAccounts() {
  const [bankAccounts, setBankAccounts] = React.useState<BankAccount[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const fetchBankAccounts = React.useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await bankAccountService.getAllBankAccounts();
      setBankAccounts(data);
    } catch (err) {
      console.error("Error fetching bank accounts:", err);
      setError(err instanceof Error ? err.message : "Gagal memuat data rekening");
      setBankAccounts([]);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    fetchBankAccounts();
  }, [fetchBankAccounts]);

  return {
    bankAccounts,
    loading,
    error,
    fetchBankAccounts,
  };
}

